<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import AppPage from "./AppPage";

export default {
  name: "AppMain",
  components: { AppPage },
  data() {
    return {
      move: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      // console.log("no auth token");
      next({ name: "Login" });
    } else {
      next();
    }
  },
  mounted() {
    let userData = JSON.parse(localStorage.getItem("user"));
    if (!userData) {
      axios
        .get(apiRoutes.auth.user.url)
        .then((response) => {
          this.$store.dispatch("authUser", response.data).then((_) => {
            this.$router.push({ name: "Panel" });
          });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.removeItem("auth_token");
            this.$router.replace({ name: "Login" });
          }
        });
    } else {
      let data = {
        auth_token: localStorage.getItem("auth_token"),
        user: userData,
      };
      this.$store.dispatch("authUser", data);
    }
  },
};
</script>

<style scoped>
</style>